import {
  Box,
  Chip,
  Icon,
  InlineMessage,
  Typography,
} from "@saviynt/design-system";
import { useState, useRef } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { POLICY_MAX_TAGS } from "../../../constants/policies.constants";
import { usePoliciesForm } from "../PoliciesFormContext";

export default function PoliciesTags() {
  const intl = useIntl();
  const { tags, setTags } = usePoliciesForm();
  const [inputVal, setInputVal] = useState("");
  const inputRef = useRef<HTMLInputElement>(null);

  const isMaxReached = tags.length >= POLICY_MAX_TAGS;

  const addTag = (val: string) => {
    const trimmed = val.trim();
    if (trimmed && !tags.includes(trimmed) && tags.length < POLICY_MAX_TAGS) {
      setTags([...tags, trimmed]);
    }
    setInputVal("");
  };

  const removeTag = (tag: string) => setTags(tags.filter((t) => t !== tag));

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      addTag(inputVal);
    } else if (e.key === "Backspace" && inputVal === "" && tags.length > 0) {
      removeTag(tags[tags.length - 1]);
    }
  };

  const handleContainerClick = () => {
    if (inputRef.current) inputRef.current.focus();
  };

  const handleBlur = () => {
    if (inputVal.trim()) addTag(inputVal);
  };

  return (
    <Box className="Policies-InputField-flexBox">
      <Typography kind="label" desktop="h3-d" mobile="h3-d">
        <FormattedMessage
          defaultMessage="Tags"
          id="3iwq9u"
          description="Label for tags selection"
        />
      </Typography>
      <div
        className="Policies-InputField-tagInput"
        onClick={handleContainerClick}
        role="presentation"
      >
        {tags.map((tag) => (
          <Chip
            key={tag}
            label={tag}
            size="small"
            kind="subtleFilled"
            color="brandPrimary"
            leftIcon={<Icon kind="Tag" size="xxxSmall" />}
            rightIcon={<Icon kind="Close" size="xxxSmall" />}
            onClick={() => removeTag(tag)}
          />
        ))}
        {!isMaxReached && (
          <input
            ref={inputRef}
            className="Policies-InputField-tagInput-input"
            value={inputVal}
            placeholder={
              tags.length === 0
                ? intl.formatMessage({
                    defaultMessage: "Add tags...",
                    id: "vE0pDh",
                    description: "Placeholder for tags input",
                  })
                : ""
            }
            onChange={(e) => setInputVal(e.target.value)}
            onKeyDown={handleKeyDown}
            onBlur={handleBlur}
          />
        )}
      </div>
      {isMaxReached && (
        <InlineMessage
          leftIcon={<Icon kind="AlertCriticalFilled" />}
          colorTheme="disabled"
          text={intl.formatMessage(
            {
              defaultMessage:
                "Maximum {maxTags, plural, one {# tag} other {# tags}} allowed",
              id: "cmuuYF",
              description: "Info message for maximum tags allowed",
            },
            { maxTags: POLICY_MAX_TAGS },
          )}
        />
      )}
    </Box>
  );
}
